import React from 'react';
import Box from '@mui/material/Box';

/** «Toca **Guardar**» → «Toca <strong>Guardar</strong>» (las guías y los recorridos marcan así los textos de pantalla). */
export const withBold = (text: string): React.ReactNode[] =>
  text.split(/(\*\*[^*]+\*\*)/g).filter(Boolean).map((part, i) =>
    part.startsWith('**') && part.endsWith('**') ? <strong key={i}>{part.slice(2, -2)}</strong> : <React.Fragment key={i}>{part}</React.Fragment>,
  );

/**
 * Texto de un paso del recorrido: párrafos separados por salto de línea, listas con «- » al inicio de la
 * línea y **negrilla** para los textos de pantalla.
 */
export const renderTourText = (text: string): React.ReactNode => {
  const blocks: React.ReactNode[] = [];
  let items: string[] = [];
  const flush = () => {
    if (!items.length) return;
    blocks.push(
      <Box component="ul" key={`ul${blocks.length}`} sx={{ m: 0, pl: 2.25, display: 'grid', gap: 0.5 }}>
        {items.map((item, i) => (
          <li key={i}>{withBold(item)}</li>
        ))}
      </Box>,
    );
    items = [];
  };
  for (const line of text.split('\n')) {
    if (line.startsWith('- ')) {
      items.push(line.slice(2));
      continue;
    }
    flush();
    if (line.trim()) blocks.push(<Box component="p" key={`p${blocks.length}`} sx={{ m: 0 }}>{withBold(line)}</Box>);
  }
  flush();
  return <Box sx={{ display: 'grid', gap: 1, '& strong': { color: 'text.primary', fontWeight: 600 } }}>{blocks}</Box>;
};
